module.exports = __webpack_public_path__ + "static/media/classResultTemp.fbe9ac59.xlsx";